const invertedMessages = {
  Remove: 'external.rules.tabs.remove',
  Cancel: 'external.rules.tabs.cancel',
  'Review Rule and Make Changes if necessary': 'external.rules.tabs.reviewtext',
  'Show User Samples': 'external.rules.tabs.showUserSamples',
  'Hide User Samples': 'external.rules.tabs.hideUserSamples',
  'Loading sample users': 'external.rules.tabs.loadingUserSamples',
  'Based on the following user data sample:': 'external.rules.tabContent.title',
  'Applies to': 'external.rules.tabContent.appliesTo',
  'External Users': 'external.rules.tabContent.externalUsers',
  'No matching users.': 'external.rules.tabContent.noMatchingUsers',
  Confirmed: 'external.rules.confirmed',
  Confirm: 'external.rules.confirm',
  'Create New Rule': 'external.rules.create',
};

export default invertedMessages;
